import { BaseDto } from '@greco/util-dto';
import { Expose } from 'class-transformer';
import { IsNotEmpty, IsOptional, IsString } from 'class-validator';

export class CreateVideoTagDto extends BaseDto {
  @Expose()
  @IsString()
  @IsNotEmpty()
  label: string;

  @Expose()
  @IsString()
  @IsOptional()
  icon?: string;
}
